<template>
  <v-app-bar
    dark
    prominent
    :src="'data:image/png;base64,' + imageUrl"
    flat
    tile
    height="400px"
  >
    <template v-slot:img="{ props }">
      <v-img
        fill v-bind="props"
        class="primary
        lighten-2"
      />
    </template>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      default: ''
    }
  }
}
</script>
